module.exports = __webpack_public_path__ + "img/color_anaranjado.388a13e7.svg";